import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Toolbar,
  Typography,
  IconButton,
  TextField,
  Stack,
  Button,
  CircularProgress,
  Snackbar,
  Alert
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { getValidatePassword } from "../api/services/payrollentry.service";
import { useAlerts } from "../Hooks";
import { sharedSnackbarAlertSx } from "../HelperFunctions/HelperFunctions";

const UnlockDialog = ({ open, onClose, onSuccess, corporationId }) => {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { snackbar, showErrorSnackbar, hideSnackbar } = useAlerts();

  const handleUnlock = async () => {
    if (!password) {
      showErrorSnackbar("Please enter a password.");
      return;
    }

    setSubmitting(true);
    try {
      // const payload = {
      //   CorpID: corporationId,
      //   Password: password,
      // };
      const response = await getValidatePassword(corporationId,password);

      if (response === true || response?.StatusCode === 200 || response?.Status === "Success" || response?.isValid || response?.status === true) {
        onSuccess();
        setPassword("");
      } else {
        showErrorSnackbar("Invalid password.");
        setPassword("");
        
      }
    } catch (error) {
      showErrorSnackbar(error.message || "Failed to validate password.");
      setPassword("");
      
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth >
      {/* HEADER */}
      <Toolbar
        sx={{
          backgroundColor: "#F1F3F5",
          minHeight: "40px !important",
          px: 2,
        }}
      >
        <Typography
          sx={{
            flex: 1,
            color: "#2F80ED",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          Security Lock
        </Typography>

        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "grey",
            borderRadius: "2px",
            "&:hover": { backgroundColor: "#A0A0A0" },
          }}
        >
          <Close sx={{ fontSize: 14, color: "#fff" }} />
        </IconButton>
      </Toolbar>

      {/* BODY */}
      <DialogContent sx={{ px: 4, pt: 3, pb: 2 }}>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          Password
        </Typography>

        <TextField
          fullWidth
          type="password"
          size="small"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              height: 32, // 🔽 reduce overall height
              borderRadius: "6px",
            },
            "& .MuiOutlinedInput-input": {
              padding: "6px 10px", // 🔽 reduce inner padding
              fontSize: "13px",
            },
          }}
        />

        {/* Divider */}
        <div
          style={{
            borderTop: "1px solid #E0E0E0",
            margin: "5px 0 10px",
          }}
        />

        {/* BUTTONS */}
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={handleUnlock}
            disabled={submitting}
            sx={{
              minWidth: 80,          // 🔽 smaller width
              height: 30,            // 🔽 smaller height
              px: 1.5,               // 🔽 horizontal padding
              fontSize: "11px",      // 🔽 smaller text
              textTransform: "none",
              borderRadius: "5px",
              color: "white",
              backgroundColor: "#3A5A78",
              "&:hover": { backgroundColor: "#2F4B66" },
            }}
          >
            {submitting ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              "Unlock"
            )}
          </Button>

          <Button
            variant="contained"
            onClick={onClose}
            disabled={submitting}
            sx={{
              minWidth: 80,
              height: 30,
              px: 1.5,
              fontSize: "11px",
              textTransform: "none",
              borderRadius: "5px",
              backgroundColor: "#F5D7DC",
              color: "#D32F2F",
              "&:hover": { backgroundColor: "#EFC4CB" },
            }}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={hideSnackbar} severity={snackbar.severity} sx={sharedSnackbarAlertSx} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default UnlockDialog;